import { createSlice } from '@reduxjs/toolkit';
export const closedCaptionsInitialState = {
    captions: [],
};
const slice = createSlice({
    name: 'closedCaptions',
    initialState: closedCaptionsInitialState,
    reducers: {
        showCaptions: (state, action) => ({
            captions: action.payload,
        }),
    },
});
export default slice.reducer;
export const closedCaptionsSelector = (state) => state.closedCaptions.captions || [];
export const { actions: { showCaptions }, } = slice;
//# sourceMappingURL=closedCaptions.js.map